// hooks/useStats.js
import { useState, useEffect } from 'react';

export const useStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStats = async () => {
    const token = localStorage.getItem('token');
    
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      //const response = await fetch('http://localhost:8080/api/v1/auth/stats', {
      const response = await fetch('https://api.juntaletras.com.br/api/v1/auth/stats', {
        method: 'GET',
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Falha ao carregar estatísticas');
      }

      const data = await response.json();
      setStats(data);
      console.log("data stats>>>>:",data)
    } catch (err) {
      console.error('Erro ao carregar estatísticas:', err);
      setError(err.message);
      setStats(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return { stats, loading, error, refetchStats: fetchStats };
};